<template>
  <div>
    <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
      <div
        class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      >
        <div class="m-auto">
          <!-- actual modal -->
          <div
            class="w-[90vw] lg:w-[1000px] mx-auto box-effect rounded-[10px] bg-white"
          >
            <header
              id="title"
              class="bg-primary px-5 py-3 flex justify-between items-center rounded-t-[10px]"
            >
              <span class="text-white text-[14px]">แก้ไขข้อมูลผู้ใช้งาน</span>
              <CloseIcon
                @click="closeModal"
                class="w-6 h-6 text-primary bg-white inline-block rounded-full cursor-pointer"
              />
            </header>
            <div
              v-if="editMode"
              class="p-5 pt-3 flex flex-col md:flex-row gap-[30px]"
            >
              <div class="mx-auto">
                <UploadImage
                  :image="formData?.image"
                  @update:image="handleImageUpload"
                  class=""
                />
              </div>
              <section class="flex-1">
                <form @submit.prevent="updateProfile">
                  <div class="max-h-[602px] overflow-auto mb-4 pr-2.5">
                    <div class="flex flex-col gap-4">
                      <div class="flex flex-col md:flex-row gap-[14px]">
                        <SelectBox
                          class="flex-none"
                          id="prefix"
                          label="คำนำหน้า"
                          placeholder="คำนำหน้า"
                          :options="allPrefix"
                          v-model="formData.prefix_id"
                          optionToDisplay="name"
                          valueKey="id"
                          :error="errors?.prefix_id"
                        />
                        <Input
                          class="flex-1"
                          id="firstname"
                          label="ชื่อ"
                          placeholder="ชื่อ"
                          v-model="formData.firstname"
                          :error="errors?.firstname"
                        />
                        <Input
                          class="flex-1"
                          id="lastname"
                          label="นามสกุล"
                          placeholder="นามสกุล"
                          v-model="formData.lastname"
                          :error="errors?.lastname"
                        />
                      </div>
                      <Input
                        inputType="phone"
                        id="phone"
                        label="เบอร์โทรติดต่อ"
                        placeholder="เบอร์โทรติดต่อ"
                        v-model="formData.phone"
                        :error="errors?.phone"
                      />
                      <Input
                        id="username"
                        label="ชื่อผู้ใช้งาน"
                        placeholder="ชื่อผู้ใช้งาน"
                        v-model="formData.username"
                        :error="errors?.username"
                        checkOnlyEnglish
                      />
                      <Input
                        inputType="email"
                        id="email"
                        label="อีเมล"
                        placeholder="อีเมล"
                        v-model="formData.email"
                        :error="errors?.email"
                        checkOnlyEnglish
                      />
                    </div>
                    <hr class="my-5" />
                    <div class="flex flex-col gap-4">
                      <SelectBox
                        id="OfficerType"
                        label="ประเภทเจ้าหน้าที่"
                        placeholder="ประเภทเจ้าหน้าที่"
                        optionToDisplay="type"
                        valueKey="id"
                        :options="officerTypeOptions"
                        :error="errors?.type"
                        v-model="formData.type"
                        @change="handleTypeSelection"
                      />
                      <div class="grid grid-rows-2">
                        <div
                          class="flex flex-col md:flex-row gap-[14px] md:items-end mb-4"
                        >
                          <SelectBox
                            id="provinceSelector"
                            label="พื้นที่ ที่สังกัด"
                            placeholder="พื้นที่ ที่สังกัด"
                            v-model="formData.province_id"
                            valueKey="provinceCode"
                            optionToDisplay="provinceNameTh"
                            class="flex-1"
                            :error="errors?.province_id"
                            :disabled="formData.type === 1"
                          />
                          <SelectBox
                            id="districtSelector"
                            placeholder="เลือกอำเภอ"
                            class="flex-1"
                            :provinceCode="formData.province_id"
                            optionToDisplay="districtNameTh"
                            valueKey="districtCode"
                            v-model="formData.district_id"
                            :error="errors?.district_id"
                            :disabled="!formData.province_id"
                          />
                        </div>
                        <div
                          class="flex flex-col md:flex-row gap-[14px] md:items-start"
                        >
                          <SelectBox
                            v-if="formData.type === 1"
                            id="sector"
                            class="flex-1"
                            label="สังกัดหน่วยงาน"
                            placeholder="เลือกหน่วยงาน"
                            :options="departmentOptions"
                            valueKey="id"
                            v-model="formData.department_id"
                            :error="errors?.department_id"
                          />
                          <SelectBox
                            id="jobPosition"
                            class="flex-1"
                            label="ตำแหน่งงาน"
                            :options="positionOptions"
                            valueKey="id"
                            v-model="formData.position_id"
                            placeholder="เลือกตำแหน่งงาน"
                            :error="errors?.position_id"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="flex items-center justify-end gap-2.5">
                    <button
                      type="button"
                      class="btn-secondary w-1/2 md:w-[150px] min-h-[50px] px-4"
                      @click="editMode = false"
                    >
                      ยกเลิก
                    </button>
                    <button
                      class="btn w-1/2 md:w-[150px] min-h-[50px] flex justify-center items-center gap-2 PC_Body1-R disabled:!bg-grey-light disabled:!border-grey-light disabled:!cursor-not-allowed"
                      type="submit"
                      :disabled="!formFilled"
                    >
                      <span class="!text-white !font-normal">บันทึก</span>
                    </button>
                  </div>
                </form>
              </section>
            </div>
            <div v-else class="p-5">
              <div class="flex md:flex-row flex-col gap-[30px] mb-4 h-[602px]">
                <img
                  :src="formData.image"
                  alt="Profile Image"
                  class="mx-auto md:mx-0 w-40 h-40"
                />
                <div class="space-y-4 flex-1 overflow-auto">
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ชื่อ - นามสกุล</span>
                    <span class="text-base"
                      >{{ formData.firstname }} {{ formData.lastname }}</span
                    >
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">เบอร์โทรติดต่อ</span>
                    <span class="text-base">{{ formData.phone }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ชื่อผู้ใช้งาน</span>
                    <span class="text-base">{{ formData.username }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">อีเมล</span>
                    <span class="text-base">{{ formData.email }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm"
                      >ประเภทเจ้าหน้าที่</span
                    >
                    <span class="text-base bg-soft-pink p-1.5">{{
                      formData.type_name
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">พื้นที่</span>
                    <span class="text-base"
                      >อ.{{ formData.district_name_th }} จ.{{
                        formData.province_name_th
                      }}</span
                    >
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">หน่วยงาน</span>
                    <span class="text-base bg-soft-pink p-1.5">{{
                      formData.department_name || "-"
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">ตำแหน่งงาน</span>
                    <span class="text-base">{{
                      formData.position_name || "-"
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm">สังกัดทีม</span>
                    <span class="text-base">{{
                      formData.team_name || "-"
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm"
                      >สังกัดศูนย์พักพิง</span
                    >
                    <span class="text-base">{{
                      formData.shelter_name || "-"
                    }}</span>
                  </div>
                  <div class="flex flex-col">
                    <span class="text-secondary text-sm"
                      >ตำแหน่งงานภายในศูนย์</span
                    >
                    <span class="text-base">{{
                      formData.shelter_position_name || "-"
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="w-full flex justify-end items-center gap-2.5">
                <button
                  class="text-danger-light text-sm underline px-4 hover:text-[#B73439] duration-200"
                  @click="deleteAccount"
                >
                  ลบบัญชีผู้ใช้งาน
                </button>
                <div class="w-1/2 md:w-auto text-end">
                  <button
                    class="btn w-full md:w-[118px] !min-h-[50px] px-4"
                    @click="editMode = true"
                  >
                    แก้ไขข้อมูล
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <StatusModal ref="StatusModalRef" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, inject } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { useAuthStore } from "../../pinia/authStore";
import { useUsersStore } from "../../pinia/users";
import { useDepartmentStore } from "../../pinia/department";
import { usePositionStore } from "../../pinia/position";
import { storeToRefs } from "pinia";
import { usePrefixStore } from "../../pinia/prefix";

const loader = inject("loader");
const emit = defineEmits(["refresh"]);

const router = useRouter();
const { allPrefix } = storeToRefs(usePrefixStore());
const modalIsOpened = ref(false);
const StatusModalRef = ref("");
const editMode = ref(false);
const { prefix } = useUsersStore();
const officerTypeOptions = ref([
  {
    id: 1,
    type: "ในพื้นที่",
  },
  {
    id: 2,
    type: "นอกพื้นที่",
  },
]);
const formData = ref({});
const errors = ref();
const img = ref("");

// computed properties
const departmentOptions = computed(() => {
  return useDepartmentStore().allDepartment;
});
const positionOptions = computed(() => {
  return usePositionStore().allPosition;
});
const formFilled = computed(() => {
  return (
    !!formData.value.firstname &&
    !!formData.value.lastname &&
    !!formData.value.phone &&
    !!formData.value.username &&
    !!formData.value.email
  );
});

// methods
const openModal = async () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  formData.value = await useAuthStore().getProfile();
  console.log(useAuthStore());
};

// const handleOutsideClick = (event) => {
//     // Check if the click target is inside a teleported dropdown
//     const isInsideDropdown = event.target.closest('.dropdown') ||
//                             event.target.closest('[id^="dropdown-"]') ||
//                             event.target.closest('.dropdownContainer');

//     // Only close modal if not clicking inside a dropdown
//     if (!isInsideDropdown) {
//         closeModal();
//     }
// };

const closeModal = () => {
  editMode.value = false;
  modalIsOpened.value = false;
  formData.value = {};
  errors.value = "";
  document.body.style.overflow = "auto";
};

const handleImageUpload = (imgData) => {
  img.value = imgData;
};

const updateProfile = async () => {
  let payload = {
    email: formData.value.email,
    username: formData.value.username,
    prefix_id: formData.value.prefix_id,
    firstname: formData.value.firstname,
    lastname: formData.value.lastname,
    phone: formData.value.phone,
    type: formData.value.type,
    district_id: formData.value.district_id,
    department_id: formData.value.department_id,
    position_id: formData.value.position_id,
    image: img.value !== null ? img.value : ""
  };
  try {
    // loader.value.showLoader();
    const response = await useAuthStore().updateProfile(
      payload,
      formData.value.id
    );
    if (response.status === 200) {
      closeModal();
      // loader.value.hideLoader();
      StatusModalRef.value.openModal(
        "success",
        { subHeader: response.data.message },
        ""
      );
      emit("refresh");
    }
  } catch (error) {
    errors.value = error.response.data.errors;
    // loader.value.hideLoader();
    console.log(error);
  }
};

const handleTypeSelection = async (value) => {
  if (value.id === 2) {
    formData.value.province_id = "";
    formData.value.district_id = "";
    formData.value.department_id = "";
  } else {
    formData.value.province_id = 57;
    formData.value.district_id = "";
  }
  console.log(formData.value);
};

const deleteAccount = async () => {
  StatusModalRef.value.openModal("warning", {
    subHeader: `หากลบบัญชีผู้ใช้งาน
  เจ้าของบัญชีจะไม่สามารถเข้าสู่ระบบได้อีก ต้องการลบบัญชีผู้ใช้งานหรือไม่`,
    closeButtonText: "ปิดหน้าต่าง",
    submitButtonText: "ลบบัญชีผู้ใช้งาน",
    onSubmit: async () => {
      try {
        const response = await axios.delete(`/profile`);
        if (response.status === 200) {
          await useAuthStore().logout();
          closeModal();
          router.push("/delete-account-success");
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          StatusModalRef.value.openModal("error", {
            subHeader:
              error.response.data.message ||
              `ขออภัย ไม่สามารถลบได้
              เนื่องจากบัญชีถูกผูกกับทีมปฎิบัติงาน
              หรือติดนัดหมายอยู่`,
          });
        }
        console.error("Error deleting account:", error);
      }
    },
  });
};

onMounted(async () => {
  // loader.value.showLoader();
  await useDepartmentStore().getAllDepartment();
  await usePositionStore().getAllPosition();
  // loader.value.hideLoader();
});

defineExpose({ openModal });
</script>

<style scoped></style>
